<template>
  <v-form style="font-family:Microsoft JhengHei;">
    <v-container md="12">
     
    </v-container>
  </v-form>
</template>
<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import "vue-wysiwyg/dist/vueWysiwyg.css";
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters({
      getTargetCaseId: ["getTargetCaseId"],
      idbServerUrl: ["getIdbServerUrl"]
    }),
  },
  data() {
    return {
      
      userProfile: JSON.parse(this.$localStorage.get("userProfileStr")),

    };
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),
    
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
      
      this.getInterpreterFromServer();
    },

    getInterpreterFromServer() {
      var vm = this;
      if ( vm.userProfile.memberAccount.type == "AAA" || vm.userProfile.memberAccount.type == "BBB" ) {
        vm.$router.push({
          path: "/ListOrganView/" + vm.userProfile.memberAccount.uuid
        });
      }
      if ( vm.userProfile.memberAccount.type == "CCC" ) {
        vm.$router.push({
          path: "/ListInterpreterView/" + vm.userProfile.memberAccount.uuid
        });
      }
    }

  },
  mounted() {
    var vm = this;
    vm.getInterpreterFromServer();
  }
};
</script>




